import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6340b46a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "backdrop",
              style: _normalizeStyle({ zIndex: _ctx.zIndex - 1 }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false))
            }, null, 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['right-drawer', _ctx.padded ? 'drawer-padded' : '']),
              style: _normalizeStyle(_ctx.drawerStyle)
            }, [
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "fa fa-times",
                round: "",
                flat: "",
                onClick: _ctx.close,
                style: {"position":"absolute","top":"0","right":"0"}
              }, null, 8, ["onClick"]), [
                [_vShow, _ctx.showClose]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['drawer-content', _ctx.padded ? 'drawer-padded' : ''])
              }, [
                (_ctx.component)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), _mergeProps({ key: 0 }, { ..._ctx.props, }, _toHandlers(_ctx.allHandlers)), null, 16))
                  : _createCommentVNode("", true)
              ], 2)
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}